"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMapRpc = void 0;
var AppMapRpc;
(function (AppMapRpc) {
    let Stats;
    (function (Stats) {
        let V1;
        (function (V1) {
            V1.Method = 'v1.appmap.stats';
        })(V1 = Stats.V1 || (Stats.V1 = {}));
        let V2;
        (function (V2) {
            V2.Method = 'v2.appmap.stats';
        })(V2 = Stats.V2 || (Stats.V2 = {}));
    })(Stats = AppMapRpc.Stats || (AppMapRpc.Stats = {}));
    AppMapRpc.DataFunctionName = 'appmap.data';
    AppMapRpc.FilterFunctionName = 'appmap.filter';
    AppMapRpc.MetadataFunctionName = 'appmap.metadata';
    AppMapRpc.SequenceDiagramFunctionName = 'appmap.sequenceDiagram';
})(AppMapRpc || (exports.AppMapRpc = AppMapRpc = {}));
